import Grid from "@mui/material/Grid";
import React from "react";
import {displaySchwelleWithMod} from "../../_helper/displaySchwelleWithMod";
import {Item} from "../CharStyled";
import {useSignals} from "@preact/signals-react/runtime";

export function CharWUND() {
    useSignals()
    return <Grid item sm={2} xs={4}>
        <Item>
            <div>Wundschw:</div>
            {displaySchwelleWithMod("ws")}
        </Item>
    </Grid>
}